module.exports = __webpack_public_path__ + "static/media/weekly-mockup.fe35f9d9.png";